export enum SharePlatform {
	
	FACEBOOK = "FACEBOOK",
	TWITTER = "TWITTER"
	
}
